import React from "react";
import { Box, Typography } from "@material-ui/core";
import { useSelectedTheme, useTranslate } from "../../../../../../../Hooks";
import { CustomBadge, CustomButton } from "../../../../../../../Components";

// styles
import { dncrAndConsentCradStyles } from "./styles";

// icons
import {
  CheckIcon,
  CloseXIcon,
  RefreshIcon,
} from "../../../../../../../assets/icons";

function DNCRAndConsentManagementCrad({
  isLoadingDNCR,
  onUpdateContactDNCR,
  contactDetails,
}) {
  const styles = dncrAndConsentCradStyles();
  const {
    theme: { palette },
  } = useSelectedTheme();
  const { translate: sharedTranslate } = useTranslate("SharedV2");

  return (
    <Box className={styles.wrapperDncrCard}>
      <Box className={styles.containerSection}>
        <Box className={styles.containerDncrUpdated}>
          <Typography className={styles.titleItem}>
            {sharedTranslate("DNCR")}
          </Typography>
          <CustomButton
            size="sm"
            variant="text"
            color="tertiary"
            style={{ display: "flex", gap: "12px" }}
            startIcon={
              <RefreshIcon
                width="20"
                height="20"
                fill={palette.button.primary_bg_hover}
              />
            }
            onClick={() => {
              onUpdateContactDNCR();
            }}
            disabled={isLoadingDNCR}
          >
            {sharedTranslate("Updated")}
          </CustomButton>
        </Box>
        {contactDetails?.contact_dncr?.lookupItemName ? (
          <CustomBadge
            label={contactDetails?.contact_dncr?.lookupItemName || "N/A"}
            BackgroundColor={"transparent"}
            BorderColor={"transparent"}
            Style={{ padding: "0px" }}
            Color={
              contactDetails?.contact_dncr?.lookupItemName ===
                "Manual Unblock" ||
              contactDetails?.contact_dncr?.lookupItemName === "Unblock"
                ? palette.utility.success_700
                : palette.utility.error_700
            }
            LeftIcon={
              contactDetails?.contact_dncr?.lookupItemName ===
                "Manual Unblock" ||
              contactDetails?.contact_dncr?.lookupItemName === "Unblock" ? (
                <CheckIcon
                  width="20"
                  height="20"
                  fill={palette.utility.success_500}
                />
              ) : (
                <CloseXIcon
                  width="20"
                  height="20"
                  fill={palette.utility.error_500}
                />
              )
            }
          />
        ) : (
          <CustomBadge
            label="N/A"
            BackgroundColor="transparent"
            BorderColor="transparent"
            Style={{ padding: "0px" }}
          />
        )}
      </Box>
      <Box className={styles.containerSection}>
        <Typography className={styles.titleItem}>
          {sharedTranslate("Consent-status")}
        </Typography>
        <Typography className={styles.contactConsentTitleStyle}>
          {contactDetails?.contact_consent_main?.lookupItemName || "N/A"}
        </Typography>
      </Box>
    </Box>
  );
}

export default DNCRAndConsentManagementCrad;
